<script setup lang="ts">
    import { computed } from 'vue'
    import type { DiscreteScaleLevelReadModel } from '@Scales/readmodels'

    /* ---------------- props / emits ---------------- */

    const props = defineProps<{
        propValue?: number | null
        propComment?: string | null
        propScaleLevels: DiscreteScaleLevelReadModel[]
    }>()

    const emit = defineEmits<{
        (e: 'update-value', value: number | null): void
        (e: 'update-comment', comment: string): void
    }>()

    /* ---------------- derived ---------------- */

    const value = computed<number | null>(() => props.propValue ?? null)
    const comment = computed<string | null>(() => props.propComment ?? null)
    const scaleLevels = computed(() => props.propScaleLevels)

    /* ---------------- helpers ---------------- */

    function IsSelected(val: number | null): boolean
    {
        return value.value === val
    }

    /* ---------------- actions ---------------- */

    function updateValue(val: number | null)
    {
        if (val !== value.value)
        {
            emit('update-value', val)
        } else
        {
            emit('update-value', null)
        }
    }

    function updateComment(comment: string)
    {
        emit('update-comment', comment)
    }
</script>


<template>
    <div>
        <div class="list-group">
            <button v-for="l in scaleLevels" :key="l.Value"
                    class="list-group-item list-group-item-action text-left"
                    :class="{ 'active': l.Value === value }"
                    @click="updateValue(l.Value)">
                <i class="fa" :class="l.Value === value ? 'fa-check-circle' : 'fa-circle-thin'"></i>
                {{l.Name}} ({{l.Value}})
                <p class="mb-0" v-if="l.Definition">{{l.Definition}}</p>
            </button>
        </div>

        <textarea rows="3" :value.trim="comment" @input="updateComment($event.target.value)" class="form-control my-3" placeholder="Comment..."></textarea>
    </div>
</template>